module.exports = __webpack_public_path__ + "static/media/RDGLogo.16dd7cbd.jpg";